// extracted by mini-css-extract-plugin
module.exports = {"container":"DownloadBanner_container__BkPJc","download-button":"DownloadBanner_download-button__qomnz","close-icon":"DownloadBanner_close-icon__QgjCC"};